import { type GpsConfig } from "../../../types";

export const CONFIG_GPS: GpsConfig = {
    TOLERANCIA_METROS: 20,       
    TIMEOUT_MS: 15000,           
    EDAD_MAXIMA_CACHE: 0,        
    ALTA_PRECISION: true
}